/* Starting camera for product 3D models (book GLBs from ~/Projects/3d-gen).
 *
 * The product gallery app (pmslider) creates <model-viewer> with only auto-rotate and
 * shadow-intensity, so the camera starts high (75 degrees) and far enough back for the model to
 * fit at any rotation, which leaves a wide book small in the frame. This sets a closer, eye-level
 * start that matches the Lander mockup. Shoppers can still drag, zoom and use AR; auto-rotate
 * keeps working. The book's 30-degree turn toward the fore-edge is baked into each model.
 *
 * The distance comes from the model's own size and the box it's shown in, so landscape, portrait
 * and square books (and any other 3D product) all fill about FILL of the frame without cropping
 * as they turn.
 *
 * Included from layout/theme.liquid just before </body> (see storefront_theme/README.md).
 */
(function () {
  var POLAR = 85;     // degrees from straight down; 90 is level with the model's centre
  var FOV = 24;       // vertical field of view, degrees
  var FILL = 0.8;     // share of the frame the model may take, across and up

  function frame(mv) {
    if (mv.dataset.pdTouched) return;                 // never move the camera once the shopper has
    var box = mv.getBoundingClientRect();
    if (box.width < 50 || box.height < 50 || !mv.getDimensions) return;   // hidden slide: wait
    var d = mv.getDimensions();                       // metres: x wide, y tall, z deep
    if (!(d.x > 0 && d.y > 0)) return;                // the gallery loads an empty src first
    var across = Math.sqrt(d.x * d.x + d.z * d.z);    // widest silhouette while it turns
    var t = Math.tan((FOV * Math.PI) / 360);
    var aspect = box.width / box.height;
    var dist = Math.max(d.y / FILL / (2 * t), across / FILL / (2 * t * aspect));
    mv.setAttribute('field-of-view', FOV + 'deg');
    mv.setAttribute('camera-orbit', '0deg ' + POLAR + 'deg ' + dist.toFixed(3) + 'm');
    if (mv.jumpCameraToGoal) mv.jumpCameraToGoal();
  }

  function tune(mv) {
    if (!mv || mv.dataset.pdCamera) return;
    mv.dataset.pdCamera = '1';
    mv.setAttribute('camera-orbit', '0deg ' + POLAR + 'deg auto');   // eye level from the first frame
    mv.setAttribute('field-of-view', FOV + 'deg');
    mv.addEventListener('load', function () { frame(mv); });
    mv.addEventListener('camera-change', function (e) {
      if (e.detail && e.detail.source === 'user-interaction') mv.dataset.pdTouched = '1';
    });
    if (window.ResizeObserver) new ResizeObserver(function () { frame(mv); }).observe(mv);
    if (mv.loaded) frame(mv);
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'MODEL-VIEWER') tune(node);
    else if (node.querySelectorAll) node.querySelectorAll('model-viewer').forEach(tune);
  }

  new MutationObserver(function (records) {
    records.forEach(function (r) { r.addedNodes.forEach(scan); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  scan(document.documentElement);
})();
